import styled from 'styled-components';
import { Button } from 'junto-ui';

export const Content = styled.div`
  padding: 80px 48px 56px 48px;
  align-items: center;

  @media screen and (max-width: 768px) {
    padding: 0 30px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;

  @media screen and (max-width: 768px) {
    display: none !important;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    max-width: 600px;
    overflow-x: scroll;
    margin-left: 18%;
  }
`;

export const ReponsiveWrapper = styled.div`
  display: none;
  text-align: center;

  @media screen and (max-width: 768px) {
    display: block !important;
    margin-top: 60px;
    overflow-x: hidden;
  }
`;

export const IllustrationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 280px;
  margin-left: 32px;
  margin-right: 32px;

  @media screen and (max-width: 768px) {
    display: block !important;
    width: auto;
    position: relative;
    left: ${props => props.touchDistance}px;
    transition: left ease-in-out 50ms;
    height: 400px;
  }

  @media screen and (max-width: 768px) {
    max-width: 312px;
    margin-left: 0px;
    margin-right: 0px;
  }

  @media screen and (max-height: 600px) {
    height: auto;
  }
`;

export const IllustrationTitle = styled.h4`
  font-size: 26px;
  line-height: 34px;
  color: #180a33;
  margin-bottom: 0px !important;
  text-align: left;
`;

export const IllustrationLabel = styled.p`
  font-size: 16px;
  line-height: 22px;
  color: #85909a;
  font-weight: 300;
  text-align: left;
`;

export const ButtonWrapper = styled.div`
  padding-top: 25px;
`;

export const NextButton = styled(Button)`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex !important;
  }
`;

export const StartButton = styled(Button)`
  display: flex;

  @media screen and (max-width: 768px) {
    display: ${props => (props.currentStep === 2 ? 'flex' : 'none')} !important;
  }
`;

export const DotsContainer = styled.div`
  margin-top: 20px;
  padding: 10px;
  text-align: center;

  span {
    &:nth-child(2) {
      margin-right: 8px !important;
      margin-left: 0px !important;
    }

    &:last-child {
      margin-left: 8px;
    }

    &:not(:first-child):not(:last-child) {
      margin-left: 8px;
      margin-right: 8px;
    }
  }
`;

export const CurrentDot = styled.span`
  height: 8px;
  width: 8px;
  background-color: #9000ff;
  border-radius: 50%;
  display: inline-block;
  transition: left ease-in-out 400ms;
  position: relative;
  left: ${props => 8 + props.currentStep * 24}px;
`;

export const Dot = styled.span`
  height: 8px;
  width: 8px;
  background-color: #cfdae1;
  border-radius: 50%;
  display: inline-block;
`;
